import type Client from '../client'
import PaginatedResponse from '../paginated-response'
import type {
  ErrorAble,
  RequestItemBag,
  SupplierRequestsResponse,
  SupplierRequestsCountResponse,
} from '@/api'

export default class SupplierRequests {
  constructor(private client: Client) {}

  find(
    supplierRequestId: number,
    query: RequestItemBag = {},
  ): Promise<ErrorAble<SupplierRequestsResponse>> {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(await this.client.get(`supplier-requests/${supplierRequestId}`, { query }))
      } catch (error) {
        reject(error)
      }
    })
  }

  count(): Promise<ErrorAble<SupplierRequestsCountResponse>> {
    return this.client.get('supplier-requests/count')
  }

  list(
    page: number,
    query: RequestItemBag = {},
  ): Promise<PaginatedResponse<SupplierRequestsResponse>> {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(
          new PaginatedResponse(
            await this.client.get('supplier-requests', { query: { ...query, page } }),
          ),
        )
      } catch (error) {
        reject(error)
      }
    })
  }

  update(
    supplierRequestId: number,
  ): Promise<PaginatedResponse<SupplierRequestsResponse>> {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(
          new PaginatedResponse(
            await this.client.patch(`supplier-requests/${supplierRequestId}`),
          ),
        )
      } catch (error) {
        reject(error)
      }
    })
  }
}
